import React from 'react';

import PropTypes from 'prop-types';

import { ReactComponent as SortDownIcon } from './down-icon.svg';
import { ReactComponent as SortUpIcon } from './up-icon.svg';

import './style.scss';

const CustomSortIconBig = ({sortOrder, setSort}) => {
  return (
    <div className='custom-sortbig-icon'>
      <SortUpIcon
        onClick={() => setSort('ascend')} 
        className={sortOrder === 'ascend' ? 'selected-sort' : ''} />
      <SortDownIcon
        onClick={() => setSort('descend')} 
        className={sortOrder === 'descend' ? 'selected-sort' : ''}/>
    </div>
  );
};

export default CustomSortIconBig;

CustomSortIconBig.propTypes = {
    sortOrder: PropTypes.string,
    setSort: PropTypes.func,
};
